import { createTheme } from '@mui/material/styles';
import shippoTheme from '../../styles/shippoTheme.js';

var accordionSummaryTheme = createTheme(shippoTheme, {
    components: {
        MuiAccordionSummary: {
            variants: [
                {
                    props: {
                        variant: 'disabledRotateExpandIcon',
                    },
                    style: {
                        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                            transform: 'rotate(0deg)',
                        },
                    },
                },
            ],
            styleOverrides: {
                root: {
                    paddingLeft: '0',
                    paddingRight: '0',
                },
                content: {
                    marginTop: '1.5rem',
                    marginBottom: '1.5rem',
                },
            },
        },
    },
});

export { accordionSummaryTheme as default };
//# sourceMappingURL=AccordionSummary.theme.js.map
